import { gql } from '@apollo/client';
import { USE_ALL_POSTS_FOR_ENTITY_SEARCH_POST_FRAGMENT } from '../search/entitySearch/useAllPostsForEntitySearch';
import TopicFields from './fragments/TopicFields';

export default gql`
  mutation createPost(
    $title: String
    $topicId: ID
    $templateId: ID
    $libraryName: String
    $source: String
  ) {
    post: createPost(
      title: $title
      topicId: $topicId
      templateId: $templateId
      libraryName: $libraryName
      source: $source
    ) {
      id
      publishedAt
      title
      ...useAllPostsForEntitySearch_post
      topics {
        ...TopicFields
      }
    }
  }
  ${TopicFields}
  ${USE_ALL_POSTS_FOR_ENTITY_SEARCH_POST_FRAGMENT}
`;
